import { dayjs, isSameDay } from 'utils/date';

export const isSlotToday = (slotStartDateTime: string | undefined): boolean =>
  !!slotStartDateTime && isSameDay(dayjs(slotStartDateTime).tz(), dayjs().tz());
